export const NR_WELCOME_LAYOUT = 'nr-welcome';
export const NR_WELCOME_ROOT_CLASS = 'nr-welcome';

/**
 * Toggle the root checkout container class used by page CSS (e.g. `.scene_holder`
 * layout for NR welcome-kit offers). Section-level `nr-welcome` classes remain
 * on markup; this mirrors legacy inline body_js boot behavior.
 *
 * @param {{ layout?: string }|null|undefined} productData
 * @param {HTMLElement|null|undefined} rootEl
 */
export const syncNrWelcomeRootClass = (productData, rootEl = null) => {
	const el = rootEl ?? (typeof document !== 'undefined' ? document.getElementById('checkout-app-new') : null);
	if (!el) {
		return;
	}

	el.classList.toggle(NR_WELCOME_ROOT_CLASS, productData?.layout === NR_WELCOME_LAYOUT);
};
